import { DatePipe } from '@angular/common';
import { Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';
import * as moment from 'moment';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Constant } from 'src/Constant';
import { GlobalServiceService } from '../Services/GlobalService/global-service.service';
import { map } from 'rxjs/operators';
import { Http } from '@angular/http'
@Component({
  selector: 'app-sachet-journey',
  templateUrl: './sachet-journey.component.html',
  styleUrls: ['./sachet-journey.component.css']
})
export class SachetJourneyComponent implements OnInit {

  selectedPaymentOption: string = 'debitNetbankingeNach';
  isChecked: boolean = false;
  @ViewChild('collapseThree') collapseThree!: ElementRef;


  @ViewChild('myDiv') myDiv!: ElementRef;
  @ViewChild('ccsiform') ccsiform!: ElementRef;
  @ViewChild('enachform') enachform!: ElementRef;
  @ViewChild('enachform_NGIN') enachform_NGIN!: ElementRef;
  @ViewChild('upiform') upiform!: ElementRef;
  public isstatus: any;
  public userdata: any;
  modalRef!: BsModalRef;
  emandate: any;
  upiUrl: any;
  ccsi: any;
  enach: any;
  ccsiReturnUrl: any;
  template: any

  policyno: any;
  renPayMode: any;
  isInHouseApplNo: boolean = false;
  blockAcDtls: boolean = true;

  //activate international ccsi start 
  ccsiPayglocal: any;
  datePipe: DatePipe = new DatePipe('en-US');



  nriFLAG: any;
  showCCSI = false;
  showCCSINRI = false;
  showNACH = false;
  showUPI = false;

  flag: any;
 // transId: any;
  channel: any;
  frequency: any;
  source: any;

  proceedFlaf: any = true;

  //activate international ccsi end
  enableForNACHVendor: any = "PAYGLOCAL";
  enableForCCSIVendor: any = "PAYGLOCAL";
  enableForUPIVendor: any = "PAYGLOCAL";

  isSystem: any = "O";
  routingInfoList: any = [];
  showAccodian3: boolean = false;
  callbackURL: any;
  displayNum: any = "";
  public Amount: any;

  public userDatanewCustomer: any
  constructor(private localStorageService: LocalStorageService,
    private router: Router,
    private toster: ToastrService,
    private spinner: NgxSpinnerService,
    private service: GlobalServiceService,
    private ngZone: NgZone,
    private http: Http) { }

  ngOnInit() {

    this.policyno = this.localStorageService.get('p_policy_no_auto');
    this.callbackURL = this.localStorageService.get('callbackURL');
    this.flag = this.localStorageService.get('flag');
    //this.transId = this.localStorageService.get('transId');
    this.channel = this.localStorageService.get('channel');
    this.frequency = this.localStorageService.get('frequency');
    this.source = this.localStorageService.get('source');


    this.displayNum = this.policyno;
    //this.checkSystem(this.policyno);
    this.isSystem = 'OPUS';

    setTimeout(() => {
      // this.flag = sessionStorage.getItem('flag');
      if (this.isSystem == 'NGIN') {
        this.emandate = Constant.BaseUrl + Constant.emandate_NGIN;
        this.enach = Constant.BaseUrl + Constant.enach_NGIN;
        this.upiUrl = Constant.BaseUrl + Constant.upiMandate_NGIN;
      } else {
        this.emandate = Constant.BaseUrl + Constant.emandate;
        this.ccsi = Constant.ccsi;
        this.enach = Constant.BaseUrl + Constant.enach;
        this.upiUrl = Constant.BaseUrl + Constant.upiMandate
      }

      this.checkForVendor();
      this.checkForUPIVendor();
      this.checkForCCSIVendor();

      if (this.isSystem == 'OPUS') {
        // if (this.renPayMode && this.renPayMode == 'UPI_M' || this.renPayMode == 'upi_m' || this.renPayMode == 'NACH' || this.renPayMode == 'nach' || this.renPayMode == 'CCSI' || this.renPayMode == 'ccsi') {
        //   this.updateRenPayMode(this.renPayMode);
        // } else {
          this.getAllData(this.template);
       // }
      } else if (this.isSystem == 'NGIN') {
        this.getAllDataNGIN()
      } else {
        this.getAllData(this.template);
      }
    }, 500); // Wait for 2 seconds


    this.userDatanewCustomer = {
      applicationNo: '',
      dateOfBirth: "",
      premiumAmount: '',
      frequency: '',
      ischecked: ''
    };
  }


  checkSystem(applicationNo: any) {
    this.spinner.show();
    let urlCheckPolicy = Constant.BaseUrl + Constant.checkPolicy;
    let reqObj1 = {
      "appln_number": applicationNo,
    }
    this.service.PostService(urlCheckPolicy, reqObj1).subscribe((response: any) => {
      console.log(response);
      if (response.statusCode == '200') {
        this.routingInfoList = response.routingInfoList[0];
        this.isSystem = this.routingInfoList.target_system;
      }
    })
  }

  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text).then(() => {
      console.log('Text copied to clipboard');
    }, (err) => {
      console.error('Could not copy text: ', err);
    });
  }


  checkForVendor() {
    //RAZORPAY,
    //TECHPROCESS, basis on that values it will enable and desabled 
    //this.enableForVendor = "TECHPROCESS";
    let url = Constant.vendorTypeNACH
    this.http.get(url).pipe(map((res: any) => res.json())).subscribe(res => {
      if (res) {
        //this.enableForVendor = res.char_VALUE;
        this.enableForNACHVendor = res[0].char_VALUE;
        // this.enableForVendor = "TECHPROCESS";
        // this.enableForVendor = "RAZORPAY";
      }
      //     this.enableForNACHVendor = "PAYGLOCAL";
    })
    if (this.isSystem == 'NGIN' || this.isSystem == 'ngin') {
      this.enableForNACHVendor = "TECHPROCESS";
    }
  }


  checkForUPIVendor() {
    //RAZORPAY,
    //TECHPROCESS, 
    //this.enableForUPIVendor = "TECHPROCESS";
    let url = Constant.vendorTypeUPI
    this.http.get(url).pipe(map((res: any) => res.json())).subscribe(res => {
      if (res) {
        this.enableForUPIVendor = res[0].char_VALUE;
        // this.enableForVendor = "TECHPROCESS";
        // this.enableForUPIVendor = "RAZORPAY";
      }
      //  this.enableForUPIVendor = "PAYGLOCAL";
    })
    if (this.isSystem == 'NGIN' || this.isSystem == 'ngin') {
      this.enableForUPIVendor = "TECHPROCESS";
    }
  }

  checkForCCSIVendor() {
    //RAZORPAY,
    //TECHPROCESS, 
    //this.enableForUPIVendor = "TECHPROCESS";
    let url = Constant.vendorTypeCCSI
    this.http.get(url).pipe(map((res: any) => res.json())).subscribe(res => {
      if (res) {
        this.enableForCCSIVendor = res[0].char_VALUE;
        // this.enableForVendor = "TECHPROCESS";
        // this.enableForUPIVendor = "RAZORPAY";
      }
      // this.enableForCCSIVendor = "PAYGLOCAL";
    })
    if (this.isSystem == 'NGIN' || this.isSystem == 'ngin') {
      this.enableForCCSIVendor = "HDFCCCSI";
    }
  }

  //update pay mode 
  updateRenPayMode(renPayMode: any) {
    let url = Constant.renPayModeChange;
    let reqObj =
    {
      appln_no: this.policyno,
      ren_pay_mode: renPayMode
    }
    this.service.PostService(url, reqObj).subscribe((response: any) => {
      console.log(response);
      if (response.errorcode == 'success') {
        // this.toster.success(response.message);
        this.getAllData(this.template);
      } else {
        this.toster.error(response.message);
      }
    })
  }


  date: any;
  newdate2: any;
  premium: any;
  freq: any;
  frequencyShow: any;
  public appl: any;
  getAllDataNGIN() {
    this.spinner.show();
    //  let url = 'https://bajajuat.bajajallianz.com/'+ Constant.getFetchAutoData_NGIN;
    let url = Constant.BaseUrl + Constant.getFetchAutoData_NGIN;
    let reqObj =
    {
      "request_source": "MR",
      "application_no": this.policyno,
      "proposal_no": "",
      "ouote_no": "",
      "mobile_no": "",
      "business_code": "",
      "user_type": "",
      "tracker_obj": {
        "domain_id": "",
        "ip_address": ""
      }
    }

    this.service.PostService(url, reqObj).subscribe((response: any) => {
      if (response.status == 'success' || response.status == 'Success' || response.status == 'SUCCESS' || response.status_code == "200") {
        if (response.tracker_out_obj &&
          response.tracker_out_obj.premium == "" ||
          response.tracker_out_obj.dob == "" ||
          response.tracker_out_obj.booking_frequency == "") {
          // this.modalRef1 = this.modalService.show(template1, { class: 'modal-md addcompmodal' });
          this.premium = '';
          this.newdate2 = '';
          this.frequencyShow = '';
        }
        if (response.tracker_out_obj != "") {
          // this.showPolicyO = false;
          //  this.showPolicyN = true;
          if (response.tracker_out_obj.premium != "") {
            this.premium = response.tracker_out_obj.premium;
            // this.showAmtO = false;
            // this.showAmtN = true;
          }
          if (response.tracker_out_obj.dob != "") {

            this.date = response.tracker_out_obj.dob;
            this.newdate2 = moment(this.date).format('DD/MM/YYYY');
            // this.newdate2 = formatDate(this.date, this.bsConfig.dateInputFormat, this.locale);
            // this.showDateO = false;
            // this.showDateN = true;

          }
          if (response.tracker_out_obj.booking_frequency != '') {
            this.freq = response.tracker_out_obj.booking_frequency;
            // this.showFreO = false;
            // this.showFreN = true;
          }

          if (response.target_system != '') {
            this.localStorageService.set('target_system', response.target_system);
          }

          if (this.freq == 'Annual' || this.freq == 'Yearly') {
            this.frequencyShow = 'Yearly';
          } else if (this.freq == 'Monthly' || this.freq == 'MONTHLY') {
            this.frequencyShow = 'Monthly';
          } else if (this.freq == 'Quarterly' || this.freq == 'QUARTERLY') {
            this.frequencyShow = 'Quarterly';
          } else if (this.freq == 'Half-Yearly' || this.freq == 'SEMI_ANNUAL' || this.freq == 'Semi-Annual') {
            this.frequencyShow = 'Half-Yearly';
          }
          this.userDatanewCustomer = {
            "applicationNo": this.appl,
            'dateOfBirth': this.newdate2,
            'premiumAmount': this.premium,
            'frequency': this.frequencyShow
          };
          this.submitNewCustomerData_NGIN();
        }
      } else {
      }
    })
  }

  submitNewCustomerData_NGIN() {
    this.spinner.show();
    this.localStorageService.set('Status', this.isstatus)

    if (this.userDatanewCustomer.dateOfBirth.length != 10) {
      // const date1 = formatDate(this.userDatanewCustomer.dateOfBirth, this.bsConfig.dateInputFormat, this.locale);
      const date1 = moment(this.userDatanewCustomer.dateOfBirth).format('DD/MM/YYYY');
      this.userDatanewCustomer.dateOfBirth = date1;
    }
    if (this.userDatanewCustomer.frequency.toString() === 'Monthly') {
      this.Amount = this.userDatanewCustomer.premiumAmount;
      // this.Amount = (this.Amount * 1.1);
      this.Amount = (this.Amount * 1.30);
    } else if (this.userDatanewCustomer.frequency.toString() === 'Quarterly') {
      this.Amount = this.userDatanewCustomer.premiumAmount;
      // this.Amount = (this.Amount * 1.1);
      this.Amount = (this.Amount * 1.30);
    } else if (this.userDatanewCustomer.frequency.toString() === 'Half-Yearly') {
      this.Amount = this.userDatanewCustomer.premiumAmount;
      //  this.Amount = (this.Amount * 1.1);
      this.Amount = (this.Amount * 1.30);
    } else if (this.userDatanewCustomer.frequency.toString() === 'Yearly') {
      this.Amount = this.userDatanewCustomer.premiumAmount;
      // this.Amount = (this.Amount * 1.1);
      this.Amount = (this.Amount * 1.30);
    }
    // let url = 'https://bajajuat.bajajallianz.com/' + Constant.setExistingCustomerData;
    let url = Constant.BaseUrl + Constant.setExistingCustomerData;
    let reqObj = {
      "p_application_no": this.userDatanewCustomer.applicationNo,
      "p_unique_id": "",
      "p_dob": this.userDatanewCustomer.dateOfBirth,
      "p_prem_amount": this.Amount.toFixed(2),
      "p_frequency_value": this.userDatanewCustomer.frequency,
      "p_module": 'OPEN_LINK_NEW',
      "p_is_unique_code": 'NO'
    }
    this.spinner.show();
    this.service.PostService(url, reqObj).subscribe((response: any) => {
      if (response.p_error_code === 'SUCCESS' || response.status === 'success') {
        //  this.spinner.hide();
        // this.localStorageService.set("userdata", response.p_data);
        // this.localStorageService.set("FLAGFOREXISTING", response.p_data.stringval11);
        // this.localStorageService.set("originalpremiumamt", this.userDatanewCustomer.premiumAmount);
        // this.localStorageService.set("mandateVal", this.Amount.toFixed(2));
        this.userdata = response.p_data;



        console.log("this.userdata :: " + this.userdata)

        if (!(this.frequency.toUpperCase() == "MONTHLY")) {
          this.frequency = "NON-MONTHLY";
        }

        if (this.channel.toUpperCase() == "PSF") {
          this.frequency = "ALL-PAYMODE";
        }


        let url = Constant.getMandateConfig;
        let reqObj =
        {
          frequency: this.frequency.toUpperCase(),
          amount: (this.userdata.stringval5),
          channel: this.channel.toUpperCase()
        }

        this.service.PostService(url, reqObj).subscribe((response: any) => {
          if (response) {
            if (response.paymodeNACH == "Y") {
              this.proceedFlaf = true;
              this.showNACH = true;
            }
            // if (response.paymodeUPI == "Y") {
            //   this.proceedFlaf = true;
            //   this.showUPI = true;
            // }
            // if (response.paymodeCCSI == "Y") {
            //   this.proceedFlaf = true;
            //   this.showCCSI = true;
            // }

          }
        })

        //GET MANDATE CONFIGURATION ENDS


        this.showCCSI = false;
        this.showUPI = false;


        console.log(" this.showCCSI" + this.showCCSI)

        this.showAccodian3 = true;

        this.router.navigate(['/Customer']);
        setTimeout(() => {
          this.spinner.hide();
        }, 1000);
      }
      else {
        this.spinner.hide();
      }
    }, (error) => {
      this.spinner.hide();
    })
  }





  // //razorpay upi implementation ends
  getAllData(template: any) {

    this.setLogs(this.policyno);


    let url = Constant.BaseUrl + Constant.getdataGenericLink;
    let reqObj =
    {
      p_application_no: this.policyno,
      p_application: "WEB"
    }

    this.spinner.show();
    this.service.PostService(url, reqObj).subscribe((response: any) => {
      let data = [];
      if (response.p_error_code === 'SUCCESS') {
        data = response.p_user_dtls;
        // console.log('here');

        console.log(data);
        // debugger
        // return;
        if (data) {
          this.userdata = response.p_user_dtls;
          // setCCSIData()  // CCSI for Existing Customer
          let [day, month, year] = this.userdata.stringval6.split(/[-\/]/);
          let [day2, month2, year2] = this.userdata.stringval7.split(/[-\/]/);

          if (day === '29' && month === '02') {
            day = '28';
            this.userdata.stringval6 = `${day}-${month}-${year}`
          }
          if (day2 === '29' && month2 === '02') {
            day2 = '28';
            this.userdata.stringval7 = `${day2}-${month2}-${year2}`
          }


          if (this.userdata.stringval13 != "") {
            this.policyno = this.userdata.stringval13
          }

          if (this.userdata.stringval14 != "") {
            this.userdata.stringval14 == '3000000007' ? this.isInHouseApplNo = true : this.isInHouseApplNo = false
          }
          if (this.userdata.stringval15 != "") {
            if (this.userdata.stringval15 == 'IPPBBC' || this.userdata.stringval15 == 'IPPB' || this.userdata.stringval15 == 'IPPBC' || this.userdata.stringval15 == 'INSTAB' || this.userdata.stringval15 == 'DIGIBANCA') {
              this.blockAcDtls = false
            } else {
              this.blockAcDtls = true
            }
          }

          // OPS-7166 starts
          if (this.userdata.stringval17 != "") {
            if (this.userdata.stringval17 == 'PSF_DEFENCE') {
              this.userdata.stringval2 = (this.userdata.stringval2 * this.userdata.stringval12)
            }
          }
          // OPS-7166 ends

          this.showAccodian3 = true;

          if (this.userdata.stringval16 != "") {
            if (this.userdata.stringval16 == 'NRI') {
              this.showCCSINRI = true;
            }
          }







          //GET MANDATE CONFIGURATION ENDS

          this.showNACH = true;

          let totalAmount = (this.userdata.stringval2 * 1.30);
          if (totalAmount > 10000000) {
            this.showNACH = false;
          }

          if (totalAmount > 15000 && this.userdata.stringval15 != 'GBOWEB') {
            this.showCCSI = false;
          } else {
            this.showCCSI = true;
          }

          //AG-2773 Start
          let url = Constant.validateUPIAgent;
          let reqObj =
          {
            agentCode: this.userdata.stringval14,
            sysType: "UPI_CONFIG"
          }
          this.spinner.show();
          this.service.PostService(url, reqObj).subscribe((response: any) => {
            debugger
            if (response.isAuthenticated === 'Y') {
              if (this.userdata.stringval15 == 'GBOWEB') {
                if ((this.userdata.stringval2 * 1.30) > 100000) {
                  this.showUPI = false;
                } else {
                  this.showUPI = true;
                }
              } else {
                if ((this.userdata.stringval2 * 1.30) > 15000) {
                  this.showUPI = false;
                } else {
                  this.showUPI = true;
                }
              }
            }
          });







          if (this.source == 'NGIN') {
            this.showCCSI = false;
          }


         // this.showUPI = false;//OPS-25566_UPI_Deactivate

        }
        else {
          alert("No Data Found");
          this.toster.error("No Data Found");
        }
      }
      else {
        alert(response.p_message);
        const newWindow = window.open('', '_self');
        if (newWindow) {
          newWindow.close();
        }
      }
      setTimeout(() => {
        /** spinner ends after 3 seconds */
        this.spinner.hide();
      }, 3000);


    })
  }


  onProceed() {
    if (this.proceedFlaf == true) {
      if (this.selectedPaymentOption === 'internationalcreditCard') {
        this.openCCSINRI();
        this.updateRenPayMode('CCSI')
      }
      else if (this.selectedPaymentOption === 'domesticcreditCard') {
        this.proceedwithCCSI();
        this.updateRenPayMode('CCSI')
      }
      else if (this.selectedPaymentOption === 'debitNetbankingeNach') {
        this.updateRenPayMode('NACH')
        this.proceedwithNACh();
      } else if (this.selectedPaymentOption === 'UPI') {
        this.updateRenPayMode('UPI_M')
        this.proceedwithUpi();
      }
    } else {
      alert("Unable to process your request!")
    }

  }




  proceedwithUpi() {
    if (this.enableForUPIVendor === 'PAYGLOCAL') {
      this.submitUPIPgcl()
    } else if (this.enableForUPIVendor == 'RAZORPAY') {
      this.payWithRozarPayforUPI();
    } else {
      this.sendUPIDataNewCust();
    }
  }

  proceedwithNACh() {
    if (this.enableForNACHVendor === 'PAYGLOCAL' && this.source != 'NGIN') {
      this.submitNACHpgcl()
    } else if (this.source == 'NGIN') {
      this.setEnachData_NGIN();
    } else {
      this.setEnachData();
    }
  }

  proceedwithEMAND() {
    if (this.enableForNACHVendor === 'PAYGLOCAL') {
      this.submitNACHpgcl()
    } else {
      this.setEmandateData();
    }
  }
  proceedwithCCSI() {
    if (this.enableForCCSIVendor === 'PAYGLOCAL') {
      this.submitCCSIpgcl()
    } else {
      this.setCCSIData();
    }
  }


  setLogs(consumerID: any) {
    let url = Constant.storeLogs;
    let reqObj =
    {
      module: "AUTOMANDATE_REG",
      consumer_id: consumerID
    }
    this.service.PostService(url, reqObj).subscribe((response: any) => {
      console.log("LOG Response :: " + response.status)
    })

  }


  setEnachData()   // ENACH FOR NEW CUSTOMER
  {
    var totalAmount: any;
    // if (this.userdata.stringval2) {
    //   totalAmount = this.isInHouseApplNo ? (this.userdata.stringval2 * 1.25) : (this.userdata.stringval2 * 1.1);
    //   // if (totalAmount > 1000000) {   // mandate value or calculated value
    //   //       totalAmount = 1000000;  // calculated value i.e mandate value will be 10 lac
    //   // } 
    // } else {
    //   totalAmount = this.userdata.stringval2;
    // }
    if (this.userdata.stringval2) {
      totalAmount = (this.userdata.stringval2 * 1.30);
    }

    var policyHolderName = this.blockAcDtls ? this.userdata.stringval1 : "";
    (<HTMLInputElement>document.getElementById("policyHolderNameenach")).value = policyHolderName;

    (<HTMLInputElement>document.getElementById("totalAmountenach")).value = parseFloat(totalAmount).toFixed(2);

    (<HTMLInputElement>document.getElementById("consumerIdenach")).value = this.policyno;

    var consumerMobileNo = this.userdata.stringval3;
    (<HTMLInputElement>document.getElementById("consumerMobileNoenach")).value = consumerMobileNo;

    var consumerEmailId = this.userdata.stringval4;
    (<HTMLInputElement>document.getElementById("consumerEmailIdenach")).value = consumerEmailId;

    var debitStartDate = this.userdata.stringval6;
    (<HTMLInputElement>document.getElementById("debitStartDateenach")).value = debitStartDate;

    var debitEndDate = this.userdata.stringval7;
    (<HTMLInputElement>document.getElementById("debitEndDateenach")).value = debitEndDate;

    var maxAmount = '100';
    (<HTMLInputElement>document.getElementById("maxAmountenach")).value = maxAmount;

    var amountType = "M";
    (<HTMLInputElement>document.getElementById("amountTypeenach")).value = amountType;

    var frequency = "ADHO";
    (<HTMLInputElement>document.getElementById("frequencyenach")).value = frequency;

    var moduleName = "INSTAB|OPEN_LINK_NEW";
    (<HTMLInputElement>document.getElementById("moduleNameenach")).value = moduleName;

    var accountNo = this.blockAcDtls ? this.userdata.stringval9 : "";
    (<HTMLInputElement>document.getElementById("accountNoe")).value = accountNo;

    var ifscCode = this.blockAcDtls ? this.userdata.stringval11 : "";
    (<HTMLInputElement>document.getElementById("ifscCodee")).value = ifscCode;

    // console.log("totalAmount is",totalAmount)

    setTimeout(() => {
      this.enachform.nativeElement.click();
    }, 1000);
  }




  setEnachData_NGIN()   // ENACH FOR NEW CUSTOMER
  {
    // console.log("this.userdata.stringval5"+this.userdata.stringval5)
    // console.log("this.userdata.stringval1"+this.userdata.stringval1)
    // console.log("this.userdata.stringval3"+this.userdata.stringval3)
    // console.log("this.userdata.stringval4"+this.userdata.stringval4)
    var policyHolderName = "";
    (<HTMLInputElement>document.getElementById("policyHolderNameenach_NGIN")).value = policyHolderName;

    var totalAmount = this.userdata.stringval5;
    (<HTMLInputElement>document.getElementById("totalAmountenach_NGIN")).value = parseFloat(totalAmount).toFixed(2)

    //var consumerId = this.userdata.stringval1;
    var consumerId = this.policyno;
    (<HTMLInputElement>document.getElementById("consumerIdenach_NGIN")).value = consumerId;

    var consumerMobileNo = "";
    (<HTMLInputElement>document.getElementById("consumerMobileNoenach_NGIN")).value = consumerMobileNo;

    var consumerEmailId = "";
    (<HTMLInputElement>document.getElementById("consumerEmailIdenach_NGIN")).value = consumerEmailId;

    var debitStartDate = this.userdata.stringval3;
    (<HTMLInputElement>document.getElementById("debitStartDateenach_NGIN")).value = debitStartDate;

    var debitEndDate = this.userdata.stringval4;
    (<HTMLInputElement>document.getElementById("debitEndDateenach_NGIN")).value = debitEndDate;

    var maxAmount = '100';
    (<HTMLInputElement>document.getElementById("maxAmountenach_NGIN")).value = maxAmount;

    var amountType = "M";
    (<HTMLInputElement>document.getElementById("amountTypeenach_NGIN")).value = amountType;

    var frequency = "ADHO";
    (<HTMLInputElement>document.getElementById("frequencyenach_NGIN")).value = frequency;

  

    setTimeout(() => {
      this.enachform_NGIN.nativeElement.click();
    }, 1000);
  }



  setEmandateData() {   //Emandate for NEW Customer

    // console.log("response.p_pymnt_list", this.userdata);

    var policyHolderName = this.blockAcDtls ? this.userdata.stringval1 : "";
    (<HTMLInputElement>document.getElementById("policyHolderNameexeman")).value = policyHolderName;

    var totalAmount = '5';
    (<HTMLInputElement>document.getElementById("totalAmountexeman")).value = totalAmount;

    (<HTMLInputElement>document.getElementById("consumerIdexeman")).value = this.policyno;

    var consumerMobileNo = this.userdata.stringval3;
    (<HTMLInputElement>document.getElementById("consumerMobileNoexeman")).value = consumerMobileNo;

    var consumerEmailId = this.userdata.stringval4;
    (<HTMLInputElement>document.getElementById("consumerEmailIdexeman")).value = consumerEmailId;

    var debitStartDate = this.userdata.stringval6;
    (<HTMLInputElement>document.getElementById("debitStartDateexeman")).value = debitStartDate;

    var debitEndDate = this.userdata.stringval7;
    (<HTMLInputElement>document.getElementById("debitEndDateexeman")).value = debitEndDate;

    var maxAmount: any;
    maxAmount = this.userdata.stringval2 * 1.30;
    //maxAmount = this.isInHouseApplNo ? (this.userdata.stringval2 * 1.25) : (this.userdata.stringval2 * 1.1);
    // var maxAmount = this.userdata.stringval8;
    (<HTMLInputElement>document.getElementById("maxAmountexeman")).value = parseFloat(maxAmount).toFixed(2);

    var amountType = "M";
    (<HTMLInputElement>document.getElementById("amountTypeexeman")).value = amountType;

    var frequency = "ADHO";
    (<HTMLInputElement>document.getElementById("frequencyexeman")).value = frequency;

    var renewalID = "";
    (<HTMLInputElement>document.getElementById("renewalIDexeman")).value = renewalID;

    var moduleName = "OPEN_LINK_NEW";
    (<HTMLInputElement>document.getElementById("moduleIdexeman")).value = moduleName;

    var payableAmount = '0';
    (<HTMLInputElement>document.getElementById("payableAmountexeman")).value = payableAmount;

    var accountNo = this.blockAcDtls ? this.userdata.stringval9 : "";
    (<HTMLInputElement>document.getElementById("accountNo")).value = accountNo;

    var ifscCode = this.blockAcDtls ? this.userdata.stringval11 : "";
    (<HTMLInputElement>document.getElementById("ifscCode")).value = ifscCode;

    setTimeout(() => {
      this.myDiv.nativeElement.click();
    }, 1000);
  }


  // setCCSIData()  // CCSI for Existing Customer
  // {

  //     // console.log("user data existing ",this.userdata)
  //     var policyHolderName =  this.userdata.stringval1;
  //     (<HTMLInputElement>document.getElementById("policyHolderccsiexi")).value = policyHolderName;

  //     var totalAmount = this.userdata.stringval2;
  //     (<HTMLInputElement>document.getElementById("totalAmountccsiexi")).value = parseFloat(totalAmount).toFixed(2);

  //     (<HTMLInputElement>document.getElementById("consumerIdccsiexi")).value = this.policyno;

  //     var consumerMobileNo = this.userdata.stringval3;
  //     (<HTMLInputElement>document.getElementById("consumerMobileNoccsiexi")).value = consumerMobileNo;

  //     var consumerEmailId = this.userdata.stringval4;
  //     (<HTMLInputElement>document.getElementById("consumerEmailIdccsiexi")).value = consumerEmailId;

  //     var debitStartDate = this.userdata.stringval6;
  //     (<HTMLInputElement>document.getElementById("debitStartDateccsiexi")).value = debitStartDate;

  //     var debitEndDate = this.userdata.stringval7;
  //     (<HTMLInputElement>document.getElementById("debitEndDateccsiexi")).value = debitEndDate;

  //     (<HTMLInputElement>document.getElementById("return_urlccsiexi")).value = this.ccsiReturnUrl;

  //   setTimeout(() => {
  //     this.ccsiform.nativeElement.click();
  //   }, 1000);
  // }

  sendUPIDataNewCust() {    // UPI Mandate for new customer
    //debugger
    var maxAmount;
    var calMaxAmt: any;
    var moduleName = this.userdata.stringval15;
    calMaxAmt = (this.userdata.stringval2 * 1.30);
    // if (moduleName == 'GBOWEB') {
    //   calMaxAmt = (this.userdata.stringval2 * 1.25);  //call no :MRKT-2104
    // } else {
    //   calMaxAmt = (this.userdata.stringval2 * 1.1);
    // }
    //console.log(this.userdata);

    // if ((this.userdata.stringval2 <= 5000) && (this.userdata.stringval8 > 5000)) {   // calulated value
    //calMaxAmt = (this.userdata.stringval2 * 1.1);
    maxAmount = calMaxAmt.toFixed(2)


    if (maxAmount > 15000) {
      alert("Mandate amount exceeds maximum amount limit.");
      return;
    } else {
      maxAmount = maxAmount;
      var policyHolderName = this.blockAcDtls ? this.userdata.stringval1 : "";
      (<HTMLInputElement>document.getElementById("policyHolderNameu")).value = policyHolderName;

      var totalAmount = '0';
      (<HTMLInputElement>document.getElementById("totalAmountu")).value = totalAmount;

      var consumerId = this.policyno;
      (<HTMLInputElement>document.getElementById("consumerIdu")).value = consumerId;

      var consumerMobileNo = this.userdata.stringval3;
      (<HTMLInputElement>document.getElementById("consumerMobileNou")).value = consumerMobileNo;

      var consumerEmailId = this.userdata.stringval4;
      (<HTMLInputElement>document.getElementById("consumerEmailIdu")).value = consumerEmailId;

      var debitStartDate = this.userdata.stringval6;
      (<HTMLInputElement>document.getElementById("debitStartDateu")).value = debitStartDate;

      var debitEndDate = this.userdata.stringval7;
      (<HTMLInputElement>document.getElementById("debitEndDateu")).value = debitEndDate;

      // var maxAmount = this.userdata.stringval8;
      (<HTMLInputElement>document.getElementById("maxAmountu")).value = maxAmount;

      var amountType = "M";
      (<HTMLInputElement>document.getElementById("amountTypeu")).value = 'M'

      var frequency = "ADHO";
      (<HTMLInputElement>document.getElementById("frequencyu")).value = frequency;

      var renewalID = "OPEN_LINK_NEW";
      (<HTMLInputElement>document.getElementById("renewalIDu")).value = renewalID;

      var payableAmount = '0';
      (<HTMLInputElement>document.getElementById("payableAmountu")).value = payableAmount;

      var accountNo = this.blockAcDtls ? this.userdata.stringval9 : "";
      (<HTMLInputElement>document.getElementById("accountNo")).value = accountNo;

      var ifscCode = this.blockAcDtls ? this.userdata.stringval11 : "";
      (<HTMLInputElement>document.getElementById("ifscCode")).value = ifscCode;

      setTimeout(() => {
        this.upiform.nativeElement.click();
      }, 1000);

    }


  }

  setCCSIData()  // CCSI for Existing Customer
  {

    // console.log("user data existing ",this.userdata)
    var policyHolderName = this.userdata.stringval1;
    (<HTMLInputElement>document.getElementById("policyHolderccsiexi")).value = policyHolderName;

    var totalAmount: any;
    // if (this.userdata.stringval2) {
    //   totalAmount = this.isInHouseApplNo ? (this.userdata.stringval2 * 1.25) : (this.userdata.stringval2 * 1.1);
    // } else {
    //   totalAmount = this.userdata.stringval2;
    // }
    if (this.userdata.stringval2) {
      totalAmount = this.userdata.stringval2 * 1.30;
    }

    (<HTMLInputElement>document.getElementById("totalAmountccsiexi")).value = parseFloat(totalAmount).toFixed(0);

    (<HTMLInputElement>document.getElementById("consumerIdccsiexi")).value = this.policyno;

    var consumerMobileNo = this.userdata.stringval3;
    (<HTMLInputElement>document.getElementById("consumerMobileNoccsiexi")).value = consumerMobileNo;

    var consumerEmailId = this.userdata.stringval4;
    (<HTMLInputElement>document.getElementById("consumerEmailIdccsiexi")).value = consumerEmailId;

    var debitStartDate = this.userdata.stringval6;
    (<HTMLInputElement>document.getElementById("debitStartDateccsiexi")).value = debitStartDate;

    var debitEndDate = this.userdata.stringval7;
    (<HTMLInputElement>document.getElementById("debitEndDateccsiexi")).value = debitEndDate;

    (<HTMLInputElement>document.getElementById("return_urlccsiexi")).value = this.ccsiReturnUrl;

    setTimeout(() => {
      this.ccsiform.nativeElement.click();
    }, 1000);
  }


  //implemet international ccsi start

  openCCSINRI() {
    this.spinner.show();
    let generateURL = Constant.NRIccsi;
    var options

    const date1 = this.userdata.stringval6;
    const prt: any = moment(date1, 'DD-MM-YYYY');
    const formattedDate1 = this.datePipe.transform(prt, 'yyyyMMdd');
    const date2 = this.userdata.stringval7;
    const prt1: any = moment(date2, 'DD-MM-YYYY');
    var formattedDate2 = this.datePipe.transform(prt1, 'yyyyMMdd');



    // Calculate the year difference
    const yearDiff = moment(formattedDate2, 'YYYYMMDD').year() - moment(formattedDate1, 'YYYYMMDD').year();
    if (yearDiff > 40) {
      const maxAllowedDate: any = moment(formattedDate1, 'YYYYMMDD').add(40, 'years').subtract(1, 'day');
      formattedDate2 = this.datePipe.transform(maxAllowedDate, 'yyyyMMdd');
    }

    var totalAmount: any;
    // if (this.userdata.stringval2) {
    //   totalAmount = this.isInHouseApplNo ? (this.userdata.stringval2 * 1.25) : (this.userdata.stringval2 * 1.1);
    // } else {
    //   totalAmount = this.userdata.stringval2;
    // }
    if (this.userdata.stringval2) {
      totalAmount = this.userdata.stringval2 * 1.30;
    }

    options = {
      "merchantTxnId": this.policyno,
      "paymentType": "PGCLINTCCSI",
        "surchargeTxn":"true",
      "siAllowedPaymentMethods": ["CARD"],
      "allowedPaymentMethods": [
        {
          "paymentMethod": "CARD"
        }
      ],
      "paymentData": {
        "totalAmount": 1,
        "txnCurrency": "INR"
      },
      "riskData": {
        "customerData": {
          "customerCategory": "FC"
        }
      },
      "standingInstruction": {
        "data": {
          "maxAmount": parseFloat(totalAmount).toFixed(),
          "numberOfPayments": "N",
          "frequency": "ONDEMAND",
          "type": "VARIABLE",
          "startDate": formattedDate1,
          "endDate": formattedDate2,
          "mode": "REGISTER"
        }
      },
      "merchantCallbackURL": Constant.NRIccsiCallbackURL,
      "moduleName": "OPEN_LINK_NEW",
      "callbackURL": this.callbackURL,
      "policyHolderName": this.userdata.stringval1
    }


    this.service.PostService(generateURL, options).subscribe((response: any) => {

      if (response.status == 'INPROGRESS') {
        this.ccsiPayglocal = response.data.redirectUrl;
        // window.open(this.ccsiPayglocal.toString(), '_blank');
        // this.spinner.hide();
        this.ccsiPayglocal = response.data.redirectUrl;
        window.location.href = this.ccsiPayglocal.toString();
      } else {
        this.toster.error("ERROR :: " + response.status);
        this.spinner.hide();
      }
    })
  }

  openDomesticCCSI() {
    //this.setCCSIData();
    this.proceedwithCCSI()
  }




  //payglocal implemenation starts

  submitNACHpgcl() {
    this.spinner.show();
    let generateURL = Constant.NRIccsi;
    var options

    const date1 = this.userdata.stringval6;
    const prt = moment(date1, 'DD-MM-YYYY').toDate();
    // const prtplusoneday = moment(prt).add(1, 'day'); // add 1 day to the date
    const formattedDate1 = this.datePipe.transform(prt, 'yyyyMMdd');
    const date2 = this.userdata.stringval7;
    const prt1 = moment(date2, 'DD-MM-YYYY').toDate();
    var formattedDate2 = this.datePipe.transform(prt1, 'yyyyMMdd');


    // Calculate the year difference
    const yearDiff = moment(formattedDate2, 'YYYYMMDD').year() - moment(formattedDate1, 'YYYYMMDD').year();

    if (yearDiff > 40) {
      const maxAllowedDate: any = moment(formattedDate1, 'YYYYMMDD').add(40, 'years').subtract(1, 'day');
      formattedDate2 = this.datePipe.transform(maxAllowedDate, 'yyyyMMdd');
    }

    var totalAmount: any;
    // if (this.userdata.stringval2) {
    //   totalAmount = this.isInHouseApplNo ? (this.userdata.stringval2 * 1.25) : (this.userdata.stringval2 * 1.1);
    // } else {
    //   totalAmount = this.userdata.stringval2;
    // }

    if (this.userdata.stringval2) {
      totalAmount = this.userdata.stringval2 * 1.30;
    }


    options = {
      "merchantTxnId": this.policyno,
      "paymentType": "PGCLNACH",
      "allowedPaymentMethods": [
        {
          "paymentMethod": "DIGITAL_BANK_MANDATE"
        }
      ],
      "siAllowedPaymentMethods": ["DIGITAL_BANK_MANDATE"],
      "paymentData": {
        "totalAmount": "1",
        "txnCurrency": "INR"
      },
      "standingInstruction": {
        "data": {
          "maxAmount": parseFloat(totalAmount).toFixed(),
          "numberOfPayments": "N",
          "frequency": "ONDEMAND",
          "type": "VARIABLE",
          "startDate": formattedDate1,
          "endDate": formattedDate2,
          "mode": "REGISTER"
        }
      },
      "moduleName": "INSTAB|OPEN_LINK_NEW",
      "product": {
        "productUserName": this.userdata.stringval1
      },
      "callbackURL": this.callbackURL,
      "merchantCallbackURL": Constant.pgclNACHCallbackURL
    }


    this.service.PostService(generateURL, options).subscribe((response: any) => {
      if (response.status == 'INPROGRESS' && response.p_next_page != 'error') {
        this.ccsiPayglocal = response.data.redirectUrl;
        // window.open(this.ccsiPayglocal.toString(), '_blank');
        // this.spinner.hide();
        this.ccsiPayglocal = response.data.redirectUrl;
        window.location.href = this.ccsiPayglocal.toString();
      } else if (response.status == 'INPROGRESS' && response.p_next_page == 'error') {
        this.toster.error("ERROR :" + response.p_error_msg);
        this.spinner.hide();
      }
      else {
        this.toster.error("ERROR :: " + response.status);
        this.spinner.hide();
      }
    })

  }

  submitUPIPgcl() {
    this.spinner.show();
    let generateURL = Constant.NRIccsi;
    var options


    const date1 = this.userdata.stringval6;
    const prt = moment(date1, 'DD-MM-YYYY').toDate();
    // const prtplusoneday = moment(prt).add(1, 'day'); // add 1 day to the date
    const formattedDate1 = this.datePipe.transform(prt, 'yyyyMMdd');
    const date2 = this.userdata.stringval7;
    const prt1 = moment(date2, 'DD-MM-YYYY').toDate();
    var formattedDate2 = this.datePipe.transform(prt1, 'yyyyMMdd');

    // Calculate the year difference
    const yearDiff = moment(formattedDate2, 'YYYYMMDD').year() - moment(formattedDate1, 'YYYYMMDD').year();

    if (yearDiff > 40) {
      const maxAllowedDate: any = moment(formattedDate1, 'YYYYMMDD').add(40, 'years').subtract(1, 'day');
      formattedDate2 = this.datePipe.transform(maxAllowedDate, 'yyyyMMdd');
    }



    // var maxAmount;
    // var calMaxAmt;
    // calMaxAmt = (this.userdata.stringval2 * 1.1);
    // maxAmount =  parseFloat(calMaxAmt).toFixed(),
    var maxAmount;
    var calMaxAmt: any;
    // var moduleName = this.userdata.stringval15;
    // if (moduleName == 'GBOWEB') {
    //   calMaxAmt = (this.userdata.stringval2 * 1.25);  //call no :MRKT-2104
    // } else {
    //   calMaxAmt = (this.userdata.stringval2 * 1.1);
    // }
    calMaxAmt = (this.userdata.stringval2 * 1.30);
    maxAmount = calMaxAmt.toFixed(2)

    options = {
      "merchantTxnId": this.policyno,
      "paymentType": "PGCLUPI",
      "siAllowedPaymentMethods": ["UPI_INTENT", "UPI_COLLECT"],
      "allowedPaymentMethods": [
        {
          "paymentMethod": "UPI_INTENT"
        },
        {
          "paymentMethod": "UPI_COLLECT"
        }
      ],
      "paymentData": {
        "totalAmount": 1,
        "txnCurrency": "INR"
      },

      "standingInstruction": {
        "data": {
          "maxAmount": parseFloat(maxAmount).toFixed(),
          "numberOfPayments": "N",
          "frequency": "ONDEMAND",
          "type": "VARIABLE",
          "startDate": formattedDate1,
          "endDate": formattedDate2,
          "mode": "REGISTER"
        }
      },
      "merchantCallbackURL": Constant.pgclUPICallbackURL,
      "moduleName": "OPEN_LINK_NEW",
      "callbackURL": this.callbackURL,
      "policyHolderName": this.userdata.stringval1
    }

    if (maxAmount > 15000) {
      this.spinner.hide();
      alert("Mandate amount exceeds maximum amount limit.");
      return;
    } else {
      this.service.PostService(generateURL, options).subscribe((response: any) => {
        if (response.status == 'INPROGRESS') {
          this.ccsiPayglocal = response.data.redirectUrl;
          // window.open(this.ccsiPayglocal.toString(), '_blank');

          // this.spinner.hide();
          this.ccsiPayglocal = response.data.redirectUrl;
          window.location.href = this.ccsiPayglocal.toString();
        } else {
          this.toster.error("ERROR :: " + response.status);
          this.spinner.hide();
        }
      })
    }

  }

  submitCCSIpgcl() {
    this.spinner.show();
    let generateURL = Constant.NRIccsi;
    var options
    const date1 = this.userdata.stringval6;
    const prt: any = moment(date1, 'DD-MM-YYYY');
    //const prtplusoneday = moment(prt).add(1, 'day'); // add 1 day to the date
    const formattedDate1 = this.datePipe.transform(prt, 'yyyyMMdd');
    const date2 = this.userdata.stringval7;
    const prt1: any = moment(date2, 'DD-MM-YYYY');
    var formattedDate2 = this.datePipe.transform(prt1, 'yyyyMMdd');


    // Calculate the year difference
    const yearDiff = moment(formattedDate2, 'YYYYMMDD').year() - moment(formattedDate1, 'YYYYMMDD').year();

    if (yearDiff > 40) {
      const maxAllowedDate: any = moment(formattedDate1, 'YYYYMMDD').add(40, 'years').subtract(1, 'day');
      formattedDate2 = this.datePipe.transform(maxAllowedDate, 'yyyyMMdd');
    }

    var totalAmount: any;
    // if (this.userdata.stringval2) {
    //   totalAmount = this.isInHouseApplNo ? (this.userdata.stringval2 * 1.25) : (this.userdata.stringval2 * 1.1);
    // } else {
    //   totalAmount = this.userdata.stringval2;
    // }

    if (this.userdata.stringval2) {
      totalAmount = this.userdata.stringval2 * 1.30;
    }

    options = {
      "merchantTxnId": this.policyno,
      "paymentType": "PGCLDOMESTICCCSI",
        "surchargeTxn":"true",
      "siAllowedPaymentMethods": ["CARD"],
      "allowedPaymentMethods": [
        {
          "paymentMethod": "CARD"
        }
      ],
      "paymentData": {
        "totalAmount": 1,
        "txnCurrency": "INR"
      },
      "standingInstruction": {
        "data": {
          "maxAmount": parseFloat(totalAmount).toFixed(),
          "numberOfPayments": "N",
          "frequency": "ONDEMAND",
          "type": "VARIABLE",
          "startDate": formattedDate1,
          "endDate": formattedDate2,
          "mode": "REGISTER"
        }
      },
      "merchantCallbackURL": Constant.pgclCCSICallbackURL,
      "moduleName": "OPEN_LINK_NEW",
      "callbackURL": this.callbackURL,
      "policyHolderName": this.userdata.stringval1
    }


    this.service.PostService(generateURL, options).subscribe((response: any) => {
      if (response.status == 'INPROGRESS') {
        this.ccsiPayglocal = response.data.redirectUrl;
        // window.open(this.ccsiPayglocal.toString(), '_blank');
        // this.spinner.hide();
        this.ccsiPayglocal = response.data.redirectUrl;
        window.location.href = this.ccsiPayglocal.toString();
      } else {
        this.toster.error("ERROR :: " + response.status);
        this.spinner.hide();
      }
    })
  }

  //payglocal implemenation ends


  payWithRozarPayforUPI() {
    let data;
    let merchantID = Constant.RAZORPAY_KEY;

    var maxAmount;
    var calMaxAmt: any;
    // calMaxAmt = this.isInHouseApplNo ? (this.userdata.stringval2 * 1.25) : (this.userdata.stringval2 * 1.1);
    calMaxAmt = (this.userdata.stringval2 * 1.30);
    maxAmount = parseFloat(calMaxAmt).toFixed(),

      data = {
        'policyHolderName': '',
        'totalAmount': 0,
        'merchantId': merchantID,
        'consumerId': this.policyno,
        'consumerMobileNo': this.userdata.stringval3,
        'consumerEmailId': this.userdata.stringval4,
        'debitStartDate': this.userdata.stringval6,
        'debitEndDate': this.userdata.stringval7,
        'maxAmount': maxAmount,
        'amountType': 'M',
        'frequency': 'ADHO',
        'moduleName': "OPEN_LINK_NEW",
        // 'moduleName': "OPEN_LINK_NEW",
        'renewalID': "OPEN_LINK_NEW",
        'payableAmount': 0,
        'takeAccountNo': this.userdata.stringval9,
        'takeIFSCCode': this.userdata.stringval11,
        'prefDate': '',
        'prefType': '',
        'authType': '',
        "paymode": "upi"
      }


    let url = Constant.createCustomerUPI;
    let reqObj = data;
    this.spinner.show();
    //console.log("Request1"+reqObj)

    this.service.PostService(url, reqObj).subscribe((response: any) => {
      console.log(response);
      if (response && response.oid && response.custRes.id) {
        this.spinner.hide();
        this.callRozarPayforUPI(response.oid, response.custRes.id);
      }
      else {
        this.spinner.hide();
        alert(response.p_message);
      }
    })
  }

  callRozarPayforUPI(orderID: any, custID: any) {
    let merchantID = Constant.RAZORPAY_KEY;
    var options = {
      "key": merchantID,
      "order_id": orderID,
      "customer_id": custID,
      "recurring": "1",
      "name": "Bajaj Life Insurance Limited",
      "image": "./assets/img/bajaj-logo.png",
      "handler": (response: any) => {
        console.log(response);
        if (response) {
          localStorage.setItem("s2sResponse", JSON.stringify(response));
          this.ngZone.run(() => this.router.navigate(['/rpThankYou']))
        }
      },
      "notes": {
        "note_key 1": "",
        "note_key 2": ""
      },
      "retry": {
        "enabled": false
      },
      "hidden": {
        "email": true,
        "contact": true
      },
      "theme": {
        "color": "#3977b7"
      }
    };
    var rzp1 = new this.service.nativeWindow.Razorpay(options);
    rzp1.open();
    rzp1.on('payment.failed', (response: any) => {
      localStorage.setItem("razorpayError", JSON.stringify(response));
      this.ngZone.run(() => this.router.navigate(['/rpFailed']))
    });
  }


}

